module.exports = __webpack_public_path__ + "res/24-img_bottom.7e2d9762916b409cb3363b201af1bf8e.png";